module.exports = __webpack_public_path__ + "static/mention_02-fcf978b0f1fd8f76926cd4350a8b2eba.png";